import React from 'react';
import ContentPane from './ContentPane';
import FooterPane from './FooterPane';
import LeftSidePane from './LeftSidePane';
import "../../../../Assets/EnsembleStyles/ServiceRequest.css";

export default function RequestServiceLayout() {
    return(
       <div className="ServiceRequest_Wrapper">
        <div className="ServiceRequest_Container">
            <div>
                <LeftSidePane/> 
            </div>            
            <div className="ServiceRequest_MainContainer">
                <ContentPane/>
                <FooterPane/>
            </div>
        </div>
       </div>
    )
}